import { Login } from "../../login/login";

export function ApplicationMonitoringLogin() {
  return <Login isMonitoringLogin={true} />;
}
